import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  COUNTRYDRPDATA,
  PROVINCEDRPDATA,
  TITLEDRPDATA,
  COMPANYDRPDATA,
  CITYDRPDATA,
} from "../../../App.config";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import DropdownComponent from "../../../containers/Dropdown";

const EmployeeGeneralInformation = ({
  state,
  onDateChange,
  handleChanges,
  onDropDownChange,
  onSubmit,
}) => {
  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <h2>
                <span>Company General Information</span>
              </h2>
            </div>

            <div className="Panel-search">
              <form action="">
                <div className="row">
                  <div className="Search-check-box">
                    <div className="col-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="">
                          Select Company:
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <DropdownComponent
                          name="companyName"
                          options={COMPANYDRPDATA}
                          isMultiSelect={false}
                          option_key="companyId"
                          option_display="companyName"
                          onChange={onDropDownChange}
                          values={state.companyName.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        />
                        {state.companyName?.error && (
                          <span className="error">
                            {state.companyName.error}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="">Search Employee by:</label>
                        <ul>
                          <li className="Radio-box">
                            <div className="check-col">
                              <input
                                type="radio"
                                tabIndex="-1"
                                id="By-Last-Name"
                                name="searchBy"
                                value="LastName"
                                checked={state.searchBy.value === "LastName"}
                                onChange={handleChanges}
                              />
                              <label htmlFor="By-Last-Name">By Last Name</label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                tabIndex="-1"
                                id="By-EIN"
                                name="searchBy"
                                value="EIN"
                                checked={state.searchBy.value === "EIN"}
                                onChange={handleChanges}
                              />
                              <label htmlFor="By-EIN">By EIN</label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                tabIndex="-1"
                                id="By-telephone"
                                name="searchBy"
                                value="Telephone"
                                checked={state.searchBy.value === "Telephone"}
                                onChange={handleChanges}
                              />
                              <label htmlFor="By-telephone">
                                By Telephone #
                              </label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                tabIndex="-1"
                                id="By-Refferal"
                                name="searchBy"
                                value="Reffral"
                                checked={state.searchBy.value === "Reffral"}
                                onChange={handleChanges}
                              />
                              <label htmlFor="By-Refferal">By Reffral #</label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="panel-content">
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">Date Created</label>
                      <CustomDatePicker
                        readOnly
                        selected={state.createdOnDate.value && state.createdOnDate.value}
                        onChange={(e) => {
                          onDateChange(e, "createdOnDate");
                        }}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Created By</label>
                      <input
                        readOnly
                        type="text"
                        className="form-control"
                        name="createdBy"
                        value={state.createdBy.value}
                        // onChange={handleChanges}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">Date Last Modified</label>
                      <CustomDatePicker
                        readOnly
                        selected={state.lastUpdateDate.value && state.lastUpdateDate.value}
                        onChange={(e) => {
                          onDateChange(e, "lastUpdateDate");
                        }}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        Title:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="title"
                        options={TITLEDRPDATA}
                        isMultiSelect={false}
                        option_key="tittleId"
                        option_display="tittleName"
                        onChange={onDropDownChange}
                        values={state.title.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.title?.error && (
                        <span className="error">{state.title.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        First Name
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={state.firstName.value}
                        onChange={handleChanges}
                      />
                      {state.firstName?.error && (
                        <span className="error">{state.firstName.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">Middle Name</label>
                      <input
                        type="text"
                        name="middleName"
                        value={state.middleName.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.middleName?.error && (
                        <span className="error">{state.middleName.error}</span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        value={state.lastName.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.lastName?.error && (
                        <span className="error">{state.lastName.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Street Address 1</label>
                      <input
                        type="text"
                        name="streetAddress1"
                        value={state.streetAddress1.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.streetAddress1?.error && (
                        <span className="error">
                          {state.streetAddress1.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Address 2</label>
                      <input
                        type="text"
                        name="address2"
                        value={state.address2.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.address2?.error && (
                        <span className="error">{state.address2.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        Country:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="country"
                        options={COUNTRYDRPDATA}
                        isMultiSelect={false}
                        option_key="countryId"
                        option_display="countryName"
                        onChange={onDropDownChange}
                        values={state.country.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.country?.error && (
                        <span className="error">{state.country.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        Province:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="province"
                        options={PROVINCEDRPDATA}
                        isMultiSelect={false}
                        option_key="stateId"
                        option_display="stateName"
                        onChange={onDropDownChange}
                        values={state.province.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.province?.error && (
                        <span className="error">{state.province.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        City:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="city"
                        options={CITYDRPDATA}
                        isMultiSelect={false}
                        option_key="cityId"
                        option_display="cityName"
                        onChange={onDropDownChange}
                        values={state.city.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.city?.error && (
                        <span className="error">{state.city.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        Postal Code
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="postalCode"
                        value={state.postalCode.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.postalCode?.error && (
                        <span className="error">{state.postalCode.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        Birth Date
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <CustomDatePicker
                        selected={state.birthDate.value && state.birthDate.value}
                        onChange={(e) => {
                          onDateChange(e, "birthDate");
                        }}
                        className="form-control"
                      />
                      {state.birthDate?.error && (
                        <span className="error">{state.birthDate.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Gender
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-Yes"
                              name="gender"
                              value="Male"
                              checked={state.gender.value === "Male"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Yes">Male</label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-No"
                              name="gender"
                              value="Female"
                              checked={state.gender.value === "Female"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-No">Female</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Home Telephone Number</label>
                      <input
                        type="text"
                        name="homeTelephoneNumber"
                        value={state.homeTelephoneNumber.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.homeTelephoneNumber?.error && (
                        <span className="error">
                          {state.homeTelephoneNumber.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Alternate Number</label>
                      <input
                        type="text"
                        name="alternateNumber"
                        value={state.alternateNumber.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.alternateNumber?.error && (
                        <span className="error">
                          {state.alternateNumber.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Email</label>
                      <input
                        type="text"
                        name="email"
                        value={state.email.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.email?.error && (
                        <span className="error">{state.email.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Employee Language Preference
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-Yes"
                              name="employeeLanguagePreference"
                              value="English"
                              checked={
                                state.employeeLanguagePreference.value ===
                                "English"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Yes">English</label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-No"
                              name="employeeLanguagePreference"
                              value="French"
                              checked={
                                state.employeeLanguagePreference.value ===
                                "French"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-No">French</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary"
                      >
                        Save and Move to Next Step
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeGeneralInformation;
